export default __webpack_public_path__ + "static/media/png.8cbf24cd.svg";